"use strict";

require("core-js/modules/es6.array.map");
require("core-js/modules/es6.array.is-array");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
var Languages_1 = require("../../Core/Languages");
var CartService = function () {
  function CartService() {}
  CartService.add = function (lang, id, quantity) {
    var urlLang = Languages_1.getCurrentLanguageUrl;
    return $.get(urlLang + "/a_cart/add/" + id + (quantity ? "/" + quantity : ""));
  };
  CartService.remove = function (lang, id) {
    var urlLang = Languages_1.getCurrentLanguageUrl;
    return $.get(urlLang + "/a_cart/delete/" + id);
  };
  CartService.remove_selected = function (ids) {
    var urlLang = Languages_1.getCurrentLanguageUrl;
    var query = '';
    if (Array.isArray(ids)) {
      query = '?';
      var productsString = ids.map(function (id) {
        return 'product[' + id + ']=1';
      }).join("&");
      query = query.concat(productsString);
    }
    return $.get(urlLang + "/a_cart/delete-selected/" + query);
  };
  CartService.clear = function (lang) {
    var urlLang = Languages_1.getCurrentLanguageUrl;
    return $.get(urlLang + "/a_cart/clear_all/");
  };
  CartService.clear_offer = function (lang) {
    var urlLang = Languages_1.getCurrentLanguageUrl;
    return $.get(urlLang + "/a_cart/clear_all_offer/");
  };
  CartService.update = function (id, quantity) {
    var urlLang = Languages_1.getCurrentLanguageUrl;
    return $.post(urlLang + "/a_cart/set/" + id, {
      value: quantity
    });
  };
  CartService.checkProductInTheBasket = function (lang) {
    var urlLang = Languages_1.getCurrentLanguageUrl;
    return $.ajax({
      url: urlLang + "/a_cart/check_product_in_the_basket/",
      async: false
    });
  };
  CartService.calculate = function () {
    var urlLang = Languages_1.getCurrentLanguageUrl;
    return $.get(urlLang + "/a_cart/calc/");
  };
  CartService.getDeliveryTime = function () {
    var urlLang = Languages_1.getCurrentLanguageUrl;
    return $.get(urlLang + "/a_cart/get-delivery-time/");
  };
  CartService.getProductsAddedToCart = function (ajaxURL) {
    return $.get(ajaxURL);
  };
  return CartService;
}();
exports.CartService = CartService;